import React, { useEffect, useState } from 'react';
import s from './CallManager.module.scss';

/** Isolated 1s countdown so the parent page does not re-render every tick. */
export default function AutoRefreshCountdown({
  active,
  intervalSeconds,
  resetToken = 0,
  loading = false,
  onRefresh,
}) {
  const [remaining, setRemaining] = useState(intervalSeconds);

  useEffect(() => {
    if (!active) return;
    setRemaining(intervalSeconds);
  }, [active, intervalSeconds, resetToken]);

  useEffect(() => {
    if (!active) return undefined;
    const timer = window.setInterval(() => {
      setRemaining((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => window.clearInterval(timer);
  }, [active]);

  return (
    <button
      type="button"
      className={s.refreshBtn}
      onClick={onRefresh}
      disabled={loading}
      title={`Auto-refreshing in ${Math.ceil(remaining)}s`}
    >
      <i className={`fa ${loading ? 'fa-spinner fa-spin' : 'fa-refresh'}`} />
      {!loading && (
        <div className={s.refreshProgressTrack}>
          <div
            className={s.refreshProgressBar}
            style={{
              width: `${Math.max(0, Math.min(100, (remaining / intervalSeconds) * 100))}%`,
            }}
          />
        </div>
      )}
    </button>
  );
}
